import { render, staticRenderFns } from "./mg-loading.vue?vue&type=template&id=7ff06acf&scoped=true&"
import script from "./mg-loading.vue?vue&type=script&lang=js&"
export * from "./mg-loading.vue?vue&type=script&lang=js&"
import style0 from "./mg-loading.vue?vue&type=style&index=0&id=7ff06acf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff06acf",
  null
  
)

export default component.exports